import React from 'react';
import PropTypes from 'prop-types';
import { coal, slate } from '../colors';
import BlockButton from '../Utilities/BlockButton';
const Tab = ({ id, title, description, icon: Icon, onTabClick, isActive }) => (React.createElement(BlockButton, { "data-testid": id, className: `tab ${isActive ? 'tab-active' : ''}`, onClick: event => onTabClick(event, id) },
    Icon ? React.createElement(Icon, { "data-testid": `icon-for-${id}`, weight: "light", color: isActive ? coal : slate, size: "2x" }) : null,
    React.createElement("div", null,
        React.createElement("h5", { className: `tab-title ${isActive ? 'tab-title-active' : ''}` }, title),
        description ? React.createElement("p", null, description) : null)));
Tab.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
    icon: PropTypes.func,
    onTabClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
};
export default Tab;
